import React, { useState, useEffect } from 'react';
import './news.css';
// import "../../../src/App.css";
import { HiCurrencyRupee } from "react-icons/hi";
import Helper from "../../helper";
import Appconfig from '../../config/config'
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const ExposureHeader = () => {
  const userInfo = Helper();
  const betData = useSelector((state) => state.data); // Use selector to access state
  const navigate = useNavigate();

  const [news, setNews] = useState("");
  const [balance, setBalance] = useState(0)
  const [exposure, setExposure] = useState(0)
  let balanceWithExp = balance - Math.abs(exposure);

  const navigateTo = (path) => {
    navigate(path);
  };

  function getNews() {
    var data = JSON.stringify({
      site_id: userInfo?.master_id,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}news/getNews`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result == 0) {
        } else {
          // setBalance(response.data.resultData?.balance)
          // setExposure(response.data.resultData?.exposure)
          console.log('news response', response?.data?.resultData);
          setNews(response?.data?.resultData);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  useEffect(() => {
    if (userInfo) {
      getBalance();
      getNews();
    }
  }, [userInfo, betData])

  function getBalance() {
    var data = JSON.stringify({
      user_id: userInfo?._id,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}ledger/getUserBalance`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result == 0) {
        } else {
          setBalance(response.data.resultData?.balance)
          setExposure(response.data.resultData?.exposure)
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }



  return (
    // <div className="exposure-header-wrapper">
    //   <div className="main-header">
    //     <div className="coin">
    //       <HiCurrencyRupee size={20} color=" #FFD700" style={{ marginRight: 5, marginLeft: 0, marginTop: 1 }} />
    //     </div>
    //     {userInfo ? (
    //       <>
    //         <span className='main-balance'>
    //           Main: <p>{balance && Number(balanceWithExp).toFixed(2)}</p>
    //         </span>
    //         <span className='exposure-balance' onClick={() => navigateTo('/openbets')}>
    //           Exposure: <p>{exposure && Number(exposure).toFixed(2)}</p>
    //         </span>
    //       </>
    //     ) : (
    //       <span className='main-balance'>
    //         Please login to see your balance
    //       </span>
    //     )}
    //   </div>
    // </div>
    <>
      {news && news?.length > 0 && (
        <div 
          className="w-full mb-1 rounded-lg shadow-md"
          style={{
            background: "linear-gradient(90deg, #0c9971 0%, #0aa27b 100%)",
            padding: "2px 4px",
          }}
        >
          <div className="flex items-center gap-3">
            {/* Icon Section */}
            <div className="flex items-center justify-center w-[28px] h-[28px] bg-white rounded-full shadow">
              <img
                src="https://bx-s3-dev-001.s3.ap-southeast-1.amazonaws.com/icons/announcement.png"
                alt="announcement"
                className="w-[16px] h-[16px]"
              />
            </div>

            {/* Marquee Section */}
            <marquee
              behavior="scroll"
              scrollamount="5"
              className="text-white text-[14px] font-medium tracking-wide uppercase"
            >
              {news?.map((n, index) => (
                <span key={index} className="mr-6">
                  {n.message}
                </span>
              ))}
            </marquee>
          </div>
        </div>
      )}

    </>
  );
}

export default ExposureHeader;
